import axios from "axios";

// export const BASE_URL = "https://madeinheavenserver-production.up.railway.app/";
export const BASE_URL = "https://jpsbackend.8jdp13yt.a2hosted.com/";
export const PDE = axios.create({ baseURL: BASE_URL });
